import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createBlock as _createBlock, withModifiers as _withModifiers, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-9f53f5b2")
const _hoisted_1 = { class: "p-formgroup" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-paperclip" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-map" }, null, -1)
const _hoisted_4 = {
  class: "p-d-flex p-flex-row p-flex-wrap",
  style: {"gap":"2rem"}
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-calendar" }, null, -1)
const _hoisted_6 = { class: "timing" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-dollar" }, null, -1)
const _hoisted_8 = { class: "payment" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h6", null, "Payment type:", -1)
const _hoisted_10 = { class: "p-field-radiobutton" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", null, "Cycle", -1)
const _hoisted_12 = { class: "p-field-radiobutton" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", null, "Hourly", -1)
const _hoisted_14 = { class: "payment" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h6", null, "Staggered Start:", -1)
const _hoisted_16 = { class: "p-field-radiobutton" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", null, "Yes", -1)
const _hoisted_18 = { class: "p-field-radiobutton" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", null, "No", -1)
const _hoisted_20 = { class: "p-field p-ml-4" }
const _hoisted_21 = { class: "other p-mt-3" }
const _hoisted_22 = { class: "p-field" }
const _hoisted_23 = { class: "p-field" }
const _hoisted_24 = { class: "p-field" }
const _hoisted_25 = {
  key: 0,
  class: "p-my-3"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-paperclip" }, null, -1)
const _hoisted_27 = {
  key: 0,
  class: "p-grid p-mb-3"
}
const _hoisted_28 = { class: "p-col-12 p-md-6" }
const _hoisted_29 = {
  key: 0,
  class: "p-col-12 p-md-6"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", { class: "p-mr-2" }, "Project: #ID", -1)
const _hoisted_31 = { class: "p-col-12 p-md-6" }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", { class: "p-mr-2" }, "Activity: #ID", -1)
const _hoisted_34 = { class: "p-field p-fluid" }
const _hoisted_35 = { class: "p-field p-fluid" }
const _hoisted_36 = { class: "p-field p-fluid" }
const _hoisted_37 = { class: "p-field p-fluid" }
const _hoisted_38 = { class: "p-field p-fluid" }
const _hoisted_39 = { class: "p-field p-fluid" }
const _hoisted_40 = { class: "p-field p-fluid" }
const _hoisted_41 = {
  key: 0,
  class: "p-field p-fluid"
}
const _hoisted_42 = { class: "other" }
const _hoisted_43 = {
  class: "p-field",
  style: {"flex":"1"}
}
const _hoisted_44 = {
  class: "p-field",
  style: {"flex":"1"}
}
const _hoisted_45 = { class: "other" }
const _hoisted_46 = {
  key: 0,
  class: "p-field",
  style: {"flex":"1"}
}
const _hoisted_47 = {
  class: "p-field",
  style: {"flex":"1"}
}
const _hoisted_48 = {
  class: "p-field",
  style: {"flex":"1"}
}
const _hoisted_49 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-map" }, null, -1)
const _hoisted_50 = { class: "distance" }
const _hoisted_51 = { class: "p-field p-fluid" }
const _hoisted_52 = { class: "p-field p-fluid" }
const _hoisted_53 = { class: "p-field-checkbox" }
const _hoisted_54 = { for: "is_free_dump" }
const _hoisted_55 = { class: "p-field" }
const _hoisted_56 = { class: "p-field-checkbox" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("label", { for: "can_upload_photo_load" }, "Upload load photo", -1)
const _hoisted_58 = {
  key: 0,
  class: "p-field p-fluid"
}
const _hoisted_59 = { class: "p-field p-fluid" }
const _hoisted_60 = { class: "p-field p-fluid" }
const _hoisted_61 = { class: "p-field-checkbox" }
const _hoisted_62 = { for: "is_dump_same_load_site" }
const _hoisted_63 = { class: "p-field" }
const _hoisted_64 = { class: "p-field-checkbox" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("label", { for: "can_upload_photo_dump" }, "Upload dump photo", -1)
const _hoisted_66 = { class: "p-field p-fluid" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-calendar" }, null, -1)
const _hoisted_68 = /*#__PURE__*/_createTextVNode(" Cannot editing date. There are active Tickets. ")
const _hoisted_69 = { class: "timing" }
const _hoisted_70 = { class: "p-field" }
const _hoisted_71 = { class: "p-field" }
const _hoisted_72 = { class: "p-field" }
const _hoisted_73 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_74 = { class: "p-field" }
const _hoisted_75 = { class: "p-field" }
const _hoisted_76 = { class: "expiration" }
const _hoisted_77 = { class: "p-field-checkbox" }
const _hoisted_78 = { for: "is_expire_active" }
const _hoisted_79 = { class: "p-field" }
const _hoisted_80 = { class: "p-field" }
const _hoisted_81 = { class: "expiration" }
const _hoisted_82 = { class: "p-field-checkbox" }
const _hoisted_83 = { for: "is_broker_status_at" }
const _hoisted_84 = { class: "p-field" }
const _hoisted_85 = { class: "p-field" }
const _hoisted_86 = { class: "other p-mt-3" }
const _hoisted_87 = { class: "p-field" }
const _hoisted_88 = /*#__PURE__*/_createTextVNode(" Warning: There are active Tickets that will not be updated. ")
const _hoisted_89 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-dollar" }, null, -1)
const _hoisted_90 = { class: "payment" }
const _hoisted_91 = /*#__PURE__*/_createElementVNode("h6", null, "Payment type:", -1)
const _hoisted_92 = { class: "p-field-radiobutton" }
const _hoisted_93 = /*#__PURE__*/_createElementVNode("label", { for: "cycle" }, "Cycle", -1)
const _hoisted_94 = { class: "p-field-radiobutton" }
const _hoisted_95 = /*#__PURE__*/_createElementVNode("label", { for: "hour" }, "Hourly", -1)
const _hoisted_96 = { class: "p-field-radiobutton" }
const _hoisted_97 = /*#__PURE__*/_createElementVNode("label", { for: "ton" }, "Ton", -1)
const _hoisted_98 = { class: "payment" }
const _hoisted_99 = /*#__PURE__*/_createElementVNode("h6", null, "Staggered Start:", -1)
const _hoisted_100 = { class: "p-field-radiobutton" }
const _hoisted_101 = /*#__PURE__*/_createElementVNode("label", { for: "schedule_true" }, "Yes", -1)
const _hoisted_102 = { class: "p-field-radiobutton" }
const _hoisted_103 = /*#__PURE__*/_createElementVNode("label", { for: "schedule_false" }, "No", -1)
const _hoisted_104 = { class: "p-field p-ml-4" }
const _hoisted_105 = { class: "other p-mt-3" }
const _hoisted_106 = {
  key: 0,
  class: "p-field"
}
const _hoisted_107 = {
  key: 1,
  class: "p-field"
}
const _hoisted_108 = { class: "p-field" }
const _hoisted_109 = { class: "p-field" }
const _hoisted_110 = { class: "p-field-checkbox" }
const _hoisted_111 = /*#__PURE__*/_createElementVNode("label", { for: "trucks_required_independent" }, "Manual", -1)
const _hoisted_112 = {
  key: 2,
  class: "p-field-checkbox"
}
const _hoisted_113 = /*#__PURE__*/_createElementVNode("label", { for: "is_ton_requested" }, "Tons requested on app", -1)
const _hoisted_114 = { class: "p-field-checkbox" }
const _hoisted_115 = /*#__PURE__*/_createElementVNode("label", { for: "round_to_quarter" }, "Round to nearest 15 minutes", -1)
const _hoisted_116 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-list" }, null, -1)
const _hoisted_117 = { class: "whitelist_users" }
const _hoisted_118 = { class: "p-inputgroup" }
const _hoisted_119 = { class: "p-d-flex" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_Fieldset = _resolveComponent("Fieldset")!
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_FloatLabel = _resolveComponent("FloatLabel")!
  const _component_ShiftDataAutocomplete = _resolveComponent("ShiftDataAutocomplete")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_MaterialSelect = _resolveComponent("MaterialSelect")!
  const _component_CompanyAutocomplete = _resolveComponent("CompanyAutocomplete")!
  const _component_UserFlattenAutocomplete = _resolveComponent("UserFlattenAutocomplete")!
  const _component_ZoneAutocomplete = _resolveComponent("ZoneAutocomplete")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_InlineMessage = _resolveComponent("InlineMessage")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_TimeZoneDropdown = _resolveComponent("TimeZoneDropdown")!
  const _component_ContractAutocomplete = _resolveComponent("ContractAutocomplete")!
  const _component_WhitelistUserDialog = _resolveComponent("WhitelistUserDialog")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_W3Sidebar = _resolveComponent("W3Sidebar")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("form", _hoisted_1, [
      _withDirectives(_createElementVNode("div", null, [
        _createVNode(_component_Fieldset, null, {
          legend: _withCtx(() => [
            _hoisted_2
          ]),
          default: _withCtx(() => [
            _createElementVNode("section", null, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(8, (a) => {
                return _createElementVNode("div", {
                  class: "p-field p-fluid",
                  key: `skeleton${a}`
                }, [
                  _createVNode(_component_Skeleton, { height: "2rem" })
                ])
              }), 64))
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_Fieldset, { class: "p-mt-3" }, {
          legend: _withCtx(() => [
            _hoisted_3
          ]),
          default: _withCtx(() => [
            _createElementVNode("section", _hoisted_4, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (a) => {
                return _createElementVNode("div", {
                  style: {"flex-basis":"25%"},
                  key: `skeleton2${a}`
                }, [
                  _createVNode(_component_Skeleton, {
                    height: "2rem",
                    width: "100%"
                  })
                ])
              }), 64))
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_Fieldset, { class: "p-mt-3" }, {
          legend: _withCtx(() => [
            _hoisted_5
          ]),
          default: _withCtx(() => [
            _createElementVNode("section", _hoisted_6, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (a) => {
                return _createElementVNode("div", {
                  class: "p-field",
                  key: `skeletonTiming${a}`
                }, [
                  _createVNode(_component_Skeleton, {
                    height: "2rem",
                    width: "12rem"
                  })
                ])
              }), 64))
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_Fieldset, {
          disabled: _ctx.isReadOnly,
          class: "p-mt-3"
        }, {
          legend: _withCtx(() => [
            _hoisted_7
          ]),
          default: _withCtx(() => [
            _createElementVNode("section", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_RadioButton),
                _hoisted_11
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_RadioButton),
                _hoisted_13
              ])
            ]),
            _createElementVNode("section", _hoisted_14, [
              _hoisted_15,
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_RadioButton),
                _hoisted_17
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_RadioButton),
                _hoisted_19
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_component_Skeleton, {
                  height: "2rem",
                  width: "12rem"
                })
              ])
            ]),
            _createElementVNode("section", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createVNode(_component_Skeleton, {
                  height: "2rem",
                  width: "12rem"
                })
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createVNode(_component_Skeleton, {
                  height: "2rem",
                  width: "12rem"
                })
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createVNode(_component_Skeleton, {
                  height: "2rem",
                  width: "12rem"
                })
              ])
            ])
          ]),
          _: 1
        }, 8, ["disabled"])
      ], 512), [
        [_vShow, _ctx.isLoading]
      ]),
      _withDirectives(_createElementVNode("div", null, [
        (_ctx.isStatusDropdownVisible)
          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
              _createVNode(_component_FloatLabel, {
                label: _ctx.$t('shift.status')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Dropdown, {
                    modelValue: _ctx.shift.status,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.shift.status = $event)),
                    options: _ctx.statusOptions,
                    "option-value": "value",
                    "option-label": "label"
                  }, null, 8, ["modelValue", "options"])
                ]),
                _: 1
              }, 8, ["label"])
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_Fieldset, { disabled: _ctx.isReadOnly }, {
          legend: _withCtx(() => [
            _hoisted_26
          ]),
          default: _withCtx(() => [
            _createElementVNode("section", null, [
              (_ctx.shift.project_id || _ctx.shift.activity_id)
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      (_ctx.shift.project_id)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_29, [
                            _createElementVNode("strong", null, [
                              _hoisted_30,
                              _createElementVNode("a", {
                                class: _normalizeClass({'pointer' : _ctx.imAdmin}),
                                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToProjectDetails()))
                              }, _toDisplayString(_ctx.shift.project_id) + " " + _toDisplayString(_ctx.shift.project?.name), 3)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_31, [
                      (_ctx.shift.activity_id)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_32, [
                            _createElementVNode("strong", null, [
                              _hoisted_33,
                              _createElementVNode("a", {
                                class: _normalizeClass({'pointer' : _ctx.imAdmin}),
                                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goToActivityDetails()))
                              }, _toDisplayString(_ctx.shift.activity_id) + " " + _toDisplayString(_ctx.shift.activity?.name), 3)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_34, [
                _createVNode(_component_ShiftDataAutocomplete, {
                  modelValue: _ctx.shift.job_site,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.shift.job_site = $event)),
                  field: "job_site",
                  onSelected: _ctx.onSelectedJob
                }, null, 8, ["modelValue", "onSelected"])
              ]),
              _createElementVNode("div", _hoisted_35, [
                _createVNode(_component_FloatLabel, {
                  label: _ctx.$t('shift.code')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_InputText, {
                      onFocus: _ctx.changeShiftCode,
                      modelValue: _ctx.shift.code,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.shift.code = $event))
                    }, null, 8, ["onFocus", "modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _createElementVNode("div", _hoisted_36, [
                _createVNode(_component_FloatLabel, {
                  label: _ctx.$t('shift.description')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Textarea, {
                      modelValue: _ctx.shift.description,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.shift.description = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _createElementVNode("div", _hoisted_37, [
                _createVNode(_component_ShiftDataAutocomplete, {
                  modelValue: _ctx.shift.poc_name,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.shift.poc_name = $event)),
                  field: "poc_name",
                  onSelected: _ctx.onSelectedName
                }, null, 8, ["modelValue", "onSelected"])
              ]),
              _createElementVNode("div", _hoisted_38, [
                _createVNode(_component_FloatLabel, {
                  label: _ctx.$t('shift.poc_phone')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_InputText, {
                      modelValue: _ctx.shift.poc_phone,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.shift.poc_phone = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _createElementVNode("div", _hoisted_39, [
                _createVNode(_component_FloatLabel, {
                  label: _ctx.$t('shift.poc_email')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_InputText, {
                      modelValue: _ctx.shift.poc_email,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.shift.poc_email = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_40, [
                  _createVNode(_component_FloatLabel, {
                    label: _ctx.$t('shift.public_note')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Textarea, {
                        modelValue: _ctx.shift.note_public,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.shift.note_public = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                ((_ctx.isSuperAdmin || _ctx.isCustomer || _ctx.isClient))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                      _createVNode(_component_FloatLabel, {
                        label: _ctx.$t('shift.private_note')
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Textarea, {
                            modelValue: _ctx.shift.note_private,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.shift.note_private = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("div", _hoisted_43, [
                  _createVNode(_component_FloatLabel, {
                    label: _ctx.$t('shift.cost_code')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_InputText, {
                        style: {"width":"100%"},
                        modelValue: _ctx.shift.cost_code,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.shift.cost_code = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _createElementVNode("div", _hoisted_44, [
                  _createVNode(_component_FloatLabel, {
                    label: _ctx.$t('shift.material')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_MaterialSelect, {
                        style: {"width":"100%"},
                        "show-clear": true,
                        modelValue: _ctx.shift.material_id,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.shift.material_id = $event)),
                        disabled: _ctx.isReadOnly
                      }, null, 8, ["modelValue", "disabled"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ])
              ]),
              _createElementVNode("div", _hoisted_45, [
                (_ctx.isCustomerVisible)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                      _createVNode(_component_CompanyAutocomplete, {
                        label: "Customer",
                        type: 300,
                        modelValue: _ctx.shift.customer,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.shift.customer = $event)),
                        onSelect: _ctx.onCustomerSelected
                      }, null, 8, ["modelValue", "onSelect"])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_47, [
                  _createVNode(_component_UserFlattenAutocomplete, {
                    style: {"width":"100%"},
                    label: _ctx.$t('shift.foreman'),
                    modelValue: _ctx.shift.foreman,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.shift.foreman = $event)),
                    disabled: !_ctx.shift.customer,
                    params: _ctx.userFilters,
                    queryOpts: _ctx.usersQueryOpts
                  }, null, 8, ["label", "modelValue", "disabled", "params", "queryOpts"])
                ]),
                _createElementVNode("div", _hoisted_48, [
                  _createVNode(_component_FloatLabel, { label: "PO number" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_InputText, {
                        style: {"width":"100%"},
                        modelValue: _ctx.shift.po_number,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.shift.po_number = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_Fieldset, {
          disabled: _ctx.isReadOnly,
          class: "p-mt-3"
        }, {
          legend: _withCtx(() => [
            _hoisted_49
          ]),
          default: _withCtx(() => [
            _createElementVNode("section", _hoisted_50, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_51, [
                  _createVNode(_component_FloatLabel, {
                    label: _ctx.$t('shift.load_site')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ZoneAutocomplete, {
                        customerId: _ctx.shift.customer?.id,
                        modelValue: _ctx.shift.zone_load,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.shift.zone_load = $event)),
                        onSelect: _cache[17] || (_cache[17] = ($event: any) => (_ctx.onZoneLoadSelect($event))),
                        disabled: !_ctx.shift.customer_id
                      }, null, 8, ["customerId", "modelValue", "disabled"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _createElementVNode("div", _hoisted_52, [
                  _createVNode(_component_InputText, {
                    class: "pointer",
                    readonly: "",
                    disabled: !_ctx.shift.zone_load,
                    modelValue: _ctx.shift.w3load,
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.shift.w3load = $event)),
                    placeholder: "click to edit",
                    onClick: _ctx.editW3Load
                  }, null, 8, ["disabled", "modelValue", "onClick"])
                ]),
                _createElementVNode("div", _hoisted_53, [
                  _createVNode(_component_Checkbox, {
                    id: "is_free_dump",
                    modelValue: _ctx.shift.is_free_dump,
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.shift.is_free_dump = $event)),
                    binary: true,
                    disabled: _ctx.isReadOnly
                  }, null, 8, ["modelValue", "disabled"]),
                  _createElementVNode("label", _hoisted_54, _toDisplayString(_ctx.$t('shift.free_dump')), 1)
                ]),
                _createElementVNode("div", _hoisted_55, [
                  _createElementVNode("div", _hoisted_56, [
                    _createVNode(_component_Checkbox, {
                      id: "can_upload_photo_load",
                      modelValue: _ctx.shift.can_upload_photo_load,
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.shift.can_upload_photo_load = $event)),
                      binary: true
                    }, null, 8, ["modelValue"]),
                    _hoisted_57
                  ])
                ]),
                (_ctx.isWeatherConditionsEnabled)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                      _createVNode(_component_FloatLabel, { label: "Weather condition *" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Dropdown, {
                            modelValue: _ctx.shift.weather_condition,
                            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.shift.weather_condition = $event)),
                            options: _ctx.weatherOptions,
                            "option-value": "value",
                            "option-label": "label",
                            "show-clear": false,
                            placeholder: "Select weather condition"
                          }, null, 8, ["modelValue", "options"])
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_59, [
                  _createVNode(_component_FloatLabel, {
                    label: _ctx.$t('shift.dump_site')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ZoneAutocomplete, {
                        ref: "autocomplete",
                        customerId: _ctx.shift.customer?.id,
                        modelValue: _ctx.shift.zone_dump,
                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_ctx.shift.zone_dump = $event)),
                        onSelect: _ctx.onZoneDumpSelect,
                        disabled: !_ctx.shift.customer_id
                      }, null, 8, ["customerId", "modelValue", "onSelect", "disabled"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _createElementVNode("div", _hoisted_60, [
                  _createVNode(_component_InputText, {
                    class: "pointer",
                    readonly: "",
                    disabled: !_ctx.shift.zone_dump || _ctx.shift.is_dump_same_load_site,
                    modelValue: _ctx.shift.w3dump,
                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_ctx.shift.w3dump = $event)),
                    placeholder: "click to edit",
                    onClick: _ctx.editW3Dump
                  }, null, 8, ["disabled", "modelValue", "onClick"])
                ]),
                _createElementVNode("div", _hoisted_61, [
                  _createVNode(_component_Checkbox, {
                    onChange: _ctx.onSameZoneChange,
                    id: "is_dump_same_load_site",
                    modelValue: _ctx.shift.is_dump_same_load_site,
                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (_ctx.shift.is_dump_same_load_site = $event)),
                    binary: true,
                    disabled: _ctx.isReadOnly
                  }, null, 8, ["onChange", "modelValue", "disabled"]),
                  _createElementVNode("label", _hoisted_62, _toDisplayString(_ctx.$t('shift.is_dump_same_load_site')), 1)
                ]),
                _createElementVNode("div", _hoisted_63, [
                  _createElementVNode("div", _hoisted_64, [
                    _createVNode(_component_Checkbox, {
                      id: "can_upload_photo_dump",
                      modelValue: _ctx.shift.can_upload_photo_dump,
                      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (_ctx.shift.can_upload_photo_dump = $event)),
                      binary: true
                    }, null, 8, ["modelValue"]),
                    _hoisted_65
                  ])
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_66, [
                  _createVNode(_component_FloatLabel, {
                    label: _ctx.$t('shift.distance')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_InputNumber, {
                        modelValue: _ctx.shift.distance,
                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (_ctx.shift.distance = $event)),
                        mode: "decimal",
                        locale: "en-US",
                        minFractionDigits: 1,
                        maxFractionDigits: 1
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_Fieldset, {
          class: "p-mt-3",
          disabled: _ctx.isReadOnly
        }, {
          legend: _withCtx(() => [
            _hoisted_67
          ]),
          default: _withCtx(() => [
            (_ctx.hasTickets)
              ? (_openBlock(), _createBlock(_component_InlineMessage, {
                  key: 0,
                  severity: "warn",
                  class: "p-mb-3"
                }, {
                  default: _withCtx(() => [
                    _hoisted_68
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createElementVNode("section", _hoisted_69, [
              _createElementVNode("div", _hoisted_70, [
                _createVNode(_component_FloatLabel, { label: "Start date" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Calendar, {
                      modelValue: _ctx.shift.shiftDay,
                      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (_ctx.shift.shiftDay = $event)),
                      showIcon: true,
                      showTime: false,
                      dateFormat: 'yy-mm-dd'
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_71, [
                _createVNode(_component_FloatLabel, {
                  label: _ctx.$t('shift.start_date_time')
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      class: _normalizeClass(["p-inputgroup p-inputnumber p-component p-inputwrapper", {'p-inputwrapper-filled': true}])
                    }, [
                      _createVNode(_component_Calendar, {
                        disabled: !_ctx.shift.shiftDay,
                        modelValue: _ctx.shift.startDateTime,
                        "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (_ctx.shift.startDateTime = $event)),
                        timeOnly: true,
                        hourFormat: "24"
                      }, null, 8, ["disabled", "modelValue"])
                    ])
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _createElementVNode("div", _hoisted_72, [
                _createVNode(_component_FloatLabel, {
                  label: _ctx.$t('shift.end_time')
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      class: _normalizeClass(["p-inputgroup p-inputnumber p-component p-inputwrapper", {'p-inputwrapper-filled': true}])
                    }, [
                      _createVNode(_component_Calendar, {
                        disabled: !_ctx.shift.shiftDay,
                        modelValue: _ctx.shift.endDateTime,
                        "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (_ctx.shift.endDateTime = $event)),
                        timeOnly: true,
                        hourFormat: "24"
                      }, null, 8, ["disabled", "modelValue"])
                    ])
                  ]),
                  _: 1
                }, 8, ["label"]),
                (_ctx.isOver24)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_73, "+24h"))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_74, [
                _createVNode(_component_FloatLabel, {
                  label: _ctx.$t('shift.pause_minutes')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_InputNumber, {
                      modelValue: _ctx.shift.pause_minutes,
                      "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => (_ctx.shift.pause_minutes = $event)),
                      mode: "decimal",
                      locale: "en-US"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _createElementVNode("div", _hoisted_75, [
                _createVNode(_component_TimeZoneDropdown, {
                  modelValue: _ctx.shift.zone_name,
                  "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => (_ctx.shift.zone_name = $event)),
                  disabled: _ctx.isReadOnly
                }, null, 8, ["modelValue", "disabled"])
              ])
            ]),
            _createElementVNode("section", _hoisted_76, [
              _createElementVNode("div", _hoisted_77, [
                _createVNode(_component_Checkbox, {
                  id: "is_expire_active",
                  modelValue: _ctx.shift.isExpireActive,
                  "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => (_ctx.shift.isExpireActive = $event)),
                  binary: true,
                  disabled: _ctx.isReadOnly
                }, null, 8, ["modelValue", "disabled"]),
                _createElementVNode("label", _hoisted_78, _toDisplayString(_ctx.$t('shift.active_expiration')), 1)
              ]),
              _createElementVNode("div", _hoisted_79, [
                _createVNode(_component_FloatLabel, { label: "Expire date" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Calendar, {
                      modelValue: _ctx.shift.expire_at,
                      "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => (_ctx.shift.expire_at = $event)),
                      minDate: _ctx.shift.end_datetime || _ctx.shift.shift_day,
                      showIcon: true,
                      disabled: !_ctx.shift.is_expire_active,
                      showTime: false,
                      dateFormat: _ctx.dateFormat
                    }, null, 8, ["modelValue", "minDate", "disabled", "dateFormat"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_80, [
                _createVNode(_component_FloatLabel, {
                  label: _ctx.$t('shift.expire_time')
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      class: _normalizeClass(["p-inputgroup p-inputnumber p-component p-inputwrapper", {'p-inputwrapper-filled': true}])
                    }, [
                      _createVNode(_component_Calendar, {
                        disabled: !_ctx.shift.is_expire_active,
                        inputId: "time12",
                        minDate: _ctx.shift.end_datetime || _ctx.shift.shift_day,
                        modelValue: _ctx.shift.expire_at,
                        "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => (_ctx.shift.expire_at = $event)),
                        timeOnly: true,
                        hourFormat: "24"
                      }, null, 8, ["disabled", "minDate", "modelValue"])
                    ])
                  ]),
                  _: 1
                }, 8, ["label"])
              ])
            ]),
            _createElementVNode("section", _hoisted_81, [
              _createElementVNode("div", _hoisted_82, [
                _createVNode(_component_Checkbox, {
                  id: "is_broker_status_at",
                  modelValue: _ctx.shift.isBrokerStatusActive,
                  "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => (_ctx.shift.isBrokerStatusActive = $event)),
                  binary: true,
                  disabled: _ctx.isReadOnly
                }, null, 8, ["modelValue", "disabled"]),
                _createElementVNode("label", _hoisted_83, _toDisplayString(_ctx.$t('shift.active_broker_status_notification')), 1)
              ]),
              _createElementVNode("div", _hoisted_84, [
                _createVNode(_component_FloatLabel, { label: "Notification date" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Calendar, {
                      modelValue: _ctx.shift.broker_status_at,
                      "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => (_ctx.shift.broker_status_at = $event)),
                      showIcon: true,
                      disabled: !_ctx.shift.is_broker_status_at,
                      showTime: false,
                      dateFormat: _ctx.dateFormat
                    }, null, 8, ["modelValue", "disabled", "dateFormat"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_85, [
                _createVNode(_component_FloatLabel, {
                  label: _ctx.$t('shift.broker_status_notification_time')
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      class: _normalizeClass(["p-inputgroup p-inputnumber p-component p-inputwrapper", {'p-inputwrapper-filled': true}])
                    }, [
                      _createVNode(_component_Calendar, {
                        disabled: !_ctx.shift.is_broker_status_at,
                        inputId: "time12",
                        modelValue: _ctx.shift.broker_status_at,
                        "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => (_ctx.shift.broker_status_at = $event)),
                        timeOnly: true,
                        hourFormat: "24"
                      }, null, 8, ["disabled", "modelValue"])
                    ])
                  ]),
                  _: 1
                }, 8, ["label"])
              ])
            ])
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_Fieldset, {
          disabled: _ctx.isReadOnly,
          class: "p-mt-3"
        }, {
          legend: _withCtx(() => [
            _hoisted_89
          ]),
          default: _withCtx(() => [
            _createElementVNode("section", _hoisted_86, [
              _createElementVNode("div", _hoisted_87, [
                _createVNode(_component_ContractAutocomplete, {
                  disabled: !_ctx.shift.customer,
                  contractId: _ctx.shift.contract_id,
                  customerId: _ctx.shift.customer?.id,
                  modelValue: _ctx.shift.contract,
                  "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => (_ctx.shift.contract = $event)),
                  noDropdown: true,
                  label: "Contract by customer",
                  onSelect: _ctx.onContractSelect
                }, null, 8, ["disabled", "contractId", "customerId", "modelValue", "onSelect"])
              ]),
              (_ctx.hasTickets)
                ? (_openBlock(), _createBlock(_component_InlineMessage, {
                    key: 0,
                    severity: "warn",
                    class: "p-mb-3"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_88
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("section", _hoisted_90, [
              _hoisted_91,
              _createElementVNode("div", _hoisted_92, [
                _createVNode(_component_RadioButton, {
                  id: "cycle",
                  name: "payment",
                  value: _ctx.paymentCYCLE,
                  modelValue: _ctx.shift.payment_type,
                  "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => (_ctx.shift.payment_type = $event)),
                  disabled: _ctx.isReadOnly
                }, null, 8, ["value", "modelValue", "disabled"]),
                _hoisted_93
              ]),
              _createElementVNode("div", _hoisted_94, [
                _createVNode(_component_RadioButton, {
                  id: "hour",
                  name: "payment",
                  value: _ctx.paymentHOUR,
                  modelValue: _ctx.shift.payment_type,
                  "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => (_ctx.shift.payment_type = $event)),
                  disabled: _ctx.isReadOnly
                }, null, 8, ["value", "modelValue", "disabled"]),
                _hoisted_95
              ]),
              _createElementVNode("div", _hoisted_96, [
                _createVNode(_component_RadioButton, {
                  id: "ton",
                  name: "payment",
                  value: _ctx.paymentTON,
                  modelValue: _ctx.shift.payment_type,
                  "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => (_ctx.shift.payment_type = $event)),
                  disabled: _ctx.isReadOnly
                }, null, 8, ["value", "modelValue", "disabled"]),
                _hoisted_97
              ])
            ]),
            _createElementVNode("section", _hoisted_98, [
              _hoisted_99,
              _createElementVNode("div", _hoisted_100, [
                _createVNode(_component_RadioButton, {
                  id: "schedule_true",
                  name: "schedule",
                  value: true,
                  modelValue: _ctx.shift.load_schedule,
                  "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => (_ctx.shift.load_schedule = $event)),
                  disabled: _ctx.isReadOnly
                }, null, 8, ["modelValue", "disabled"]),
                _hoisted_101
              ]),
              _createElementVNode("div", _hoisted_102, [
                _createVNode(_component_RadioButton, {
                  id: "schedule_false",
                  name: "schedule",
                  value: false,
                  modelValue: _ctx.shift.load_schedule,
                  "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => (_ctx.shift.load_schedule = $event)),
                  disabled: _ctx.isReadOnly
                }, null, 8, ["modelValue", "disabled"]),
                _hoisted_103
              ]),
              _createElementVNode("div", _hoisted_104, [
                _createVNode(_component_FloatLabel, { label: "Interval (mins)" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_InputNumber, {
                      modelValue: _ctx.shift.load_minutes,
                      "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => (_ctx.shift.load_minutes = $event)),
                      mode: "decimal",
                      locale: "en-US"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("section", _hoisted_105, [
              (_ctx.shift.payment_type == _ctx.paymentCYCLE)
                ? (_openBlock(), _createElementBlock("div", _hoisted_106, [
                    _createVNode(_component_FloatLabel, { label: "Num. of cycles expected" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_InputNumber, {
                          modelValue: _ctx.shift.cycles,
                          "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => (_ctx.shift.cycles = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              (_ctx.shift.payment_type == _ctx.paymentTON)
                ? (_openBlock(), _createElementBlock("div", _hoisted_107, [
                    _createVNode(_component_FloatLabel, { label: "Num. of tons estimated" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_InputNumber, {
                          modelValue: _ctx.shift.estimated_ton,
                          "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => (_ctx.shift.estimated_ton = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_108, [
                _createVNode(_component_FloatLabel, { label: "Min. trucks required" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_InputNumber, {
                      modelValue: _ctx.shift.trucks_min,
                      "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => (_ctx.shift.trucks_min = $event)),
                      min: 0
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_109, [
                _createVNode(_component_FloatLabel, {
                  id: "trucks_required",
                  label: "Max. trucks required"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_InputNumber, {
                      disabled: !_ctx.shift.trucks_required_indipendent,
                      modelValue: _ctx.shift.trucks_required,
                      "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => (_ctx.shift.trucks_required = $event))
                    }, null, 8, ["disabled", "modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_110, [
                _createVNode(_component_Checkbox, {
                  id: "trucks_required_independent",
                  modelValue: _ctx.shift.trucks_required_indipendent,
                  "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => (_ctx.shift.trucks_required_indipendent = $event)),
                  binary: true
                }, null, 8, ["modelValue"]),
                _hoisted_111
              ]),
              (_ctx.shift.payment_type != _ctx.paymentTON)
                ? (_openBlock(), _createElementBlock("div", _hoisted_112, [
                    _createVNode(_component_Checkbox, {
                      id: "is_ton_requested",
                      modelValue: _ctx.shift.is_ton_requested,
                      "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => (_ctx.shift.is_ton_requested = $event)),
                      binary: true,
                      disabled: _ctx.isReadOnly
                    }, null, 8, ["modelValue", "disabled"]),
                    _hoisted_113
                  ]))
                : _createCommentVNode("", true),
              _withDirectives(_createElementVNode("div", _hoisted_114, [
                _createVNode(_component_Checkbox, {
                  id: "round_to_quarter",
                  modelValue: _ctx.shift.round_to_quarter,
                  "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => (_ctx.shift.round_to_quarter = $event)),
                  binary: true,
                  disabled: _ctx.isReadOnly
                }, null, 8, ["modelValue", "disabled"]),
                _hoisted_115
              ], 512), [
                [_vShow, _ctx.shift.payment_type == _ctx.paymentHOUR]
              ])
            ])
          ]),
          _: 1
        }, 8, ["disabled"]),
        (_ctx.isWhitelistVisible)
          ? (_openBlock(), _createBlock(_component_Fieldset, {
              key: 1,
              class: "p-mt-3",
              disabled: _ctx.isReadOnly
            }, {
              legend: _withCtx(() => [
                _hoisted_116
              ]),
              default: _withCtx(() => [
                _createElementVNode("section", _hoisted_117, [
                  _createVNode(_component_WhitelistUserDialog, {
                    visible: _ctx.displayWhiteListDialog,
                    "onUpdate:visible": _cache[52] || (_cache[52] = ($event: any) => (_ctx.displayWhiteListDialog = $event)),
                    customerId: _ctx.shift.customer?.id,
                    onAddUser: _ctx.onAdd,
                    onRemoveUser: _ctx.onRemove
                  }, null, 8, ["visible", "customerId", "onAddUser", "onRemoveUser"]),
                  _createElementVNode("header", null, [
                    _createElementVNode("h4", null, _toDisplayString(_ctx.$t('shift.whitelist_brokers')), 1),
                    _createElementVNode("div", null, [
                      (_ctx.shift.id)
                        ? (_openBlock(), _createBlock(_component_Button, {
                            key: 0,
                            type: "button",
                            label: "Refresh",
                            icon: "pi pi-refresh",
                            class: "p-button-outlined p-mr-2",
                            onClick: _cache[53] || (_cache[53] = ($event: any) => (_ctx.refreshWhitelist()))
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_Button, {
                        icon: "pi pi-plus",
                        label: _ctx.$t('shift.add_broker'),
                        onClick: _cache[54] || (_cache[54] = ($event: any) => (_ctx.displayWhiteListDialog = true))
                      }, null, 8, ["label"])
                    ])
                  ]),
                  _createVNode(_component_DataTable, {
                    value: _ctx.whitelistUsers,
                    stripedRows: "",
                    rows: 10,
                    "rows-per-page-options": [10, 20, 50, 100],
                    loading: _ctx.requestPending,
                    paginator: true,
                    "auto-layout": true,
                    "striped-rows": true
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Column, {
                        field: "business_name",
                        header: "Business Name"
                      }),
                      _createVNode(_component_Column, {
                        field: "email",
                        header: "Email"
                      }),
                      _createVNode(_component_Column, {
                        field: "phone",
                        header: "Phone"
                      }),
                      _createVNode(_component_Column, {
                        field: "business_address",
                        header: "Business Address"
                      }),
                      _createVNode(_component_Column, {
                        field: "trucks_required",
                        header: "Trucks Required"
                      }, {
                        body: _withCtx(({data}) => [
                          _createElementVNode("div", _hoisted_118, [
                            _createVNode(_component_InputNumber, {
                              modelValue: data.trucks_required,
                              "onUpdate:modelValue": ($event: any) => (data.trucks_required = $event)
                            }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                            (data.trucks_required !== data.original_trucks_required && _ctx.shift.id)
                              ? (_openBlock(), _createBlock(_component_Button, {
                                  key: 0,
                                  onClick: ($event: any) => (_ctx.editWhitelistUser(data)),
                                  icon: "pi pi-check",
                                  class: "p-button-success"
                                }, null, 8, ["onClick"]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "trucks_engaged",
                        header: "Eng."
                      }),
                      _createVNode(_component_Column, {
                        header: "Actions",
                        class: "column-header-right p-text-right",
                        style: {"min-width":"100px","width":"100px"}
                      }, {
                        body: _withCtx(({data}) => [
                          _createElementVNode("div", _hoisted_119, [
                            (_ctx.canGoBroker)
                              ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                                  key: 0,
                                  class: "p-button-warning p-mr-1",
                                  icon: "pi pi-pencil",
                                  onClick: _withModifiers(($event: any) => (_ctx.showDetails(data)), ["stop"])
                                }, null, 8, ["onClick"])), [
                                  [
                                    _directive_tooltip,
                                    _ctx.$t('Edit'),
                                    void 0,
                                    { bottom: true }
                                  ]
                                ])
                              : _createCommentVNode("", true),
                            _withDirectives(_createVNode(_component_Button, {
                              class: "p-button-danger",
                              icon: "pi pi-trash",
                              onClick: _withModifiers(($event: any) => (_ctx.removeUserFromWhitelist(data)), ["stop"])
                            }, null, 8, ["onClick"]), [
                              [
                                _directive_tooltip,
                                'Remove from whitelist',
                                void 0,
                                { bottom: true }
                              ]
                            ])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value", "loading"])
                ])
              ]),
              _: 1
            }, 8, ["disabled"]))
          : _createCommentVNode("", true)
      ], 512), [
        [_vShow, !_ctx.isLoading]
      ])
    ]),
    _createVNode(_component_W3Sidebar, {
      initialValue: _ctx.initialValue,
      visible: _ctx.displayW3Sidebar,
      "onUpdate:visible": _cache[55] || (_cache[55] = ($event: any) => (_ctx.displayW3Sidebar = $event)),
      onSave: _ctx.onSaveW3
    }, null, 8, ["initialValue", "visible", "onSave"])
  ], 64))
}